import React from "react";

export default function LoadingIndicator() {
	return (
		<div className="w-16 h-16 border-4 border-blue-400 border-solid rounded-full animate-spin border-t-transparent mx-auto"></div>
	)
}